import {useMemo} from 'react';
import {IProperty} from 'modules/products/types';
import {FINE_RARE_ITEM} from 'modules/product-card/constants/characteristics';

const getProductFineAndRarePropValue = (properties: IProperty[] = []) => {
    if (!properties.length) {
        return false;
    }

    const propertyFineAndRare = properties.find(({code}) => code === FINE_RARE_ITEM.KEY);
    return Boolean(propertyFineAndRare?.value) || false;
};

export const useProductFineAndRare = (properties?: IProperty[]) => {
    return useMemo(() => getProductFineAndRarePropValue(properties), [properties]);
};
